import { getMessages } from '../../../../../../../store/constants';

export const CARD_SECTION_CUSTOM = getMessages().getText('card_form_section_custom');
export const CARD_CUSTOM_ADD = getMessages().getText('card_form_custom_add');
export const CARD_CUSTOM_ACTIONS = getMessages().getText('card_form_custom_section_actions');
export const CARD_CUSTOM_EDIT = getMessages().getText('card_form_custom_edit');
export const CARD_CUSTOM_HIDE = getMessages().getText('card_form_custom_actions_empty_hide');
export const CARD_CUSTOM_SHOW = getMessages().getText('card_form_custom_actions_empty_show');
export const CARD_CUSTOM_CANCEL = getMessages().getText('common.cancel');
